import React from "react"
import classNames from "classnames"
import styles from "./SignUpContainer.module.scss"
import Button from "../../components/Button/Button"
import { Link } from "react-router-dom"
import Bg from "../../images/signUp/bg.jpg"

const SignUpContainer = ({
  title,
  subtitle,
  description,
  children,
  onBack,
  onNext,
  isButtonSubmit,
  withBackBtn,
  className,
  currentStep,
  userRole,
  useVerticalLayout = false,
  lockedInfo,
}) => {
  // Define steps based on user role
  const getSteps = () => {
    if (userRole === "company") {
      return [
        {
          step: 1,
          title: "Step 1: Account Options",
          description: "Are you creating a professional or company account?",
        },
        {
          step: 2,
          title: "Step 2: Account Type",
          description: "Are you a seeker of opportunities or a provider of opportunities",
        },
        {
          step: 3,
          title: "Step 3: Profile Creation",
          description: "Complete info to continue to platform",
        },
      ]
    } else {
      return [
        {
          step: 1,
          title: "Step 1: Account Options",
          description: "Are you creating a professional or company account?",
        },
        {
          step: 2,
          title: "Step 2: Questionnaire",
          description: "Complete the brief questionnaire",
        },
        {
          step: 3,
          title: "Step 3: Profile Creation",
          description: "Complete info to continue to platform",
        },
      ]
    }
  }

  const steps = getSteps()
  const hasLockedInfo = Array.isArray(lockedInfo) && lockedInfo.length > 0

  // Use old layout for Step 1 and Company Step 2
  if (!useVerticalLayout) {
    return (
      <div
        className={classNames(styles.signUpContainer, styles.oldLayout, className)}
        style={{ backgroundImage: `url(${Bg})` }}
      >
        <div className={classNames("smallContainer", "fullWidth", styles.wrap)}>
          <h2 className={styles.mainTitle}>{title}</h2>
          <div className={styles.subtitleWrap}>
            <span className={classNames("text18m", styles.subtitle)}>
              {subtitle}
            </span>
            <div className={classNames("note14r", styles.description)}>
              {description}
            </div>
            {hasLockedInfo && (
              <div className={styles.lockedInfo}>
                {lockedInfo.map((item) => (
                  <div key={item.label} className={styles.lockedInfoRow}>
                    <span className={styles.lockedInfoLabel}>{item.label}:</span>{" "}
                    <span className={styles.lockedInfoValue}>{item.value}</span>
                  </div>
                ))}
              </div>
            )}
          </div>
          {children}
          <span className={classNames("note14r", styles.mobileSignInLinkWrap)}>
            Do you have an account?{" "}
            <Link to="/login" className={styles.signInLink}>
              Sign In
            </Link>
          </span>
          <div
            className={classNames(styles.actionBtnsWrap, {
              [styles.withBackBtn]: withBackBtn,
            })}
          >
            {withBackBtn && (
              <Button
                buttonStyle="outlined"
                onClick={onBack}
                className={styles.backBtn}
              >
                Back
              </Button>
            )}
            <div className={styles.nextWrap}>
              <span className={classNames("note14r", styles.signInLinkWrap)}>
                Do you have an account?{" "}
                <Link
                  to="/login"
                  className={classNames("goldLink", styles.signInLink)}
                >
                  Sign In
                </Link>
              </span>
              <Button
                type={isButtonSubmit ? "submit" : "button"}
                onClick={onNext}
                className={styles.nextBtn}
              >
                Next step
              </Button>
            </div>
          </div>
        </div>
      </div>
    )
  }

  // Use vertical layout for form pages
  return (
    <div
      className={classNames(styles.signUpContainer, styles.verticalLayout, className)}
      style={{ backgroundImage: `url(${Bg})` }}
    >
      <div className={styles.mainContent}>
        {/* Left Panel - Step Navigation */}
        <div className={styles.stepsPanel}>
          <h2 className={styles.stepsTitle}>Sign Up Process</h2>
          <div className={styles.stepsList}>
            {steps.map((step) => {
              const isActive = currentStep === step.step
              return (
                <div
                  key={step.step}
                  className={classNames(styles.stepItem, {
                    [styles.stepItemActive]: isActive,
                  })}
                >
                  <div className={styles.stepContent}>
                    <h3 className={styles.stepTitle}>{step.title}</h3>
                    <p className={styles.stepDescription}>{step.description}</p>
                  </div>
                </div>
              )
            })}
          </div>
        </div>

        {/* Right Panel - Form */}
        <div className={styles.formPanel}>
          <h3 className={styles.formTitle}>{subtitle || title}</h3>
          <div className={styles.formContent}>
            {hasLockedInfo && (
              <div className={styles.lockedInfo}>
                {lockedInfo.map((item) => (
                  <div key={item.label} className={styles.lockedInfoRow}>
                    <span className={styles.lockedInfoLabel}>{item.label}:</span>{" "}
                    <span className={styles.lockedInfoValue}>{item.value}</span>
                  </div>
                ))}
              </div>
            )}
            {children}
            <div className={styles.formActions}>
              <Button
                type={isButtonSubmit ? "submit" : "button"}
                onClick={isButtonSubmit ? () => document.getElementById("formikForm")?.requestSubmit() : onNext}
                className={styles.nextBtnFullWidth}
              >
                Next Step
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default SignUpContainer
